import type { SnippetPart } from "../../lib/api/models";

/** Text parts only: nothing here is ever parsed as HTML. */
export function Snippet({ parts }: { parts: SnippetPart[] }) {
  return (
    <span className="text-sm leading-5 text-ink-2">
      {parts.map((p, i) =>
        p.match ? (
          // biome-ignore lint/suspicious/noArrayIndexKey: parts have no identity beyond their order
          <mark key={i} className="rounded-sm bg-orange-wash px-0.5 text-ink">
            {p.text}
          </mark>
        ) : (
          // biome-ignore lint/suspicious/noArrayIndexKey: parts have no identity beyond their order
          <span key={i}>{p.text}</span>
        ),
      )}
    </span>
  );
}
